import "react-photo-album/columns.css";

// const videos = [
//   { src: "/images/gallery/videos/1.mp4", width: 3, height: 4 },
//   { src: "/images/gallery/videos/2.mp4", width: 4, height: 3 },
//   { src: "/images/gallery/videos/3.mp4", width: 3, height: 4 },
//   { src: "/images/gallery/videos/4.mp4", width: 3, height: 4 },
//   { src: "/images/gallery/videos/5.mp4", width: 3, height: 4 },
//   { src: "/images/gallery/videos/6.mp4", width: 3, height: 4 },
//   { src: "/images/gallery/videos/7.mp4", width: 4, height: 3 },
//   { src: "/images/gallery/videos/8.mp4", width: 4, height: 3 },
// ];

export default function VideoGallery() {
  return (
    <div style={{ padding: 8, maxWidth: 1100, margin: "0 auto" }}>
  
    </div>
  );
}
